import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { makeStyles } from '@mui/styles'

import DetailsBackButton from '../../dashboard/clients/DetailsBackButton'

const useStyles = makeStyles(
  (theme) => ({
    backButton: {
      width: 'max-content',
    },
    backButtonContainer: {
      flex: 0,
    },
    backButtonIcon: {
      color: theme.colors.grayGray1,
    },
  }),
  { name: 'ContextualBackButton' },
)

interface ContextualBackButtonProps {
  buttonText: string
  navigateBackToContext: () => void
}

export const ContextualBackButton = ({
  buttonText,
  navigateBackToContext,
}: ContextualBackButtonProps) => {
  const { t } = useTranslation('Common')
  const classes = useStyles()
  const navigate = useNavigate()

  const navigateBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1)
    } else {
      navigateBackToContext()
    }
  }

  return (
    <Box
      alignItems="center"
      bgcolor={(theme) => theme.colors.grayGray4}
      display="flex"
      gap={1}
      height={40}
      justifyContent="flex-start"
    >
      <DetailsBackButton
        thin
        classes={{
          container: classes.backButtonContainer,
          button: classes.backButton,
          thinArrow: classes.backButtonIcon,
        }}
        onClick={navigateBack}
      >
        {t('Common:BACK_ACTION')}
      </DetailsBackButton>
      <DetailsBackButton
        thin
        classes={{
          container: classes.backButtonContainer,
          button: classes.backButton,
        }}
        showIcon={false}
        onClick={navigateBackToContext}
      >
        {buttonText}
      </DetailsBackButton>
    </Box>
  )
}
